<template>
  <VueSlickCarousel v-bind="carouselSettings">
    <slot></slot>
  </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "Carousel",
  components: { VueSlickCarousel },
  props: {
    carouselSettings: Object,
  },
};
</script>

<style scoped lang="scss">
::v-deep .slick-arrow {
  position: absolute;
  z-index: 9;
  left: -45px;
  top: 50%;
  background: none;
  border: none;
  font-size: 0;
  text-indent: -9999px;
  border: 2px solid $color-orange;
  width: 30px;
  height: 30px;
  border-radius: 100%;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &.slick-next {
    left: auto;
    right: -45px;
    transform: rotate(180deg);
  }

  &:before,
  &:after {
    content: "";
    width: 2px;
    height: 7px;
    display: block;
    position: absolute;
    transform: rotate(-40deg);
    background: $color-orange;
    left: 11px;
    top: 12px;
    opacity: 1;
  }

  &:after {
    top: 7px;
    transform: rotate(40deg);
  }

  &.slick-disabled {
    border-color: $color-dark-600;

    &:before,
    &:after {
      background: $color-dark-600;
      opacity: 1;
    }
  }
}

::v-deep .slick-track {
  display: flex !important;
  .slick-slide {
    height: auto !important;
    > div {
      height: 100%;
      > div {
        height: 100%;
      }
    }
  }
}

::v-deep .slick-list {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

::v-deep ul.slick-dots {
  li {
    margin: 0;
    width: 10px;
    button {
      &:before {
        color: $color-orange;
      }
    }
  }
}
</style>
